import { PropsWithChildren } from 'react';

import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps, PropsWithChildren {}

export const RiskLevelSection = ({ children, ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section datax="riskLevelSection" title={t('client.riskLevel.title')}>
      <GridFields>
        <FormContent {...formProps} />
        {children}
      </GridFields>
    </Section>
  );
};
